const secToMin = (sec) => {
    return ( Math.floor(sec / 60)
    .toString()
    .padStart(1, "0") +
    ":" +
    (sec % 60).toString().padStart(2, "0") );
}
 
export default secToMin;